import { motion } from "framer-motion";
import { chakra, shouldForwardProp } from "@chakra-ui/react";
import React from "react";

const StyledDiv = chakra(motion.div, {
  shouldForwardProp: (prop) => {
    return shouldForwardProp(prop) || prop === "transition";
  },
});

interface SectionProps {
    delay: number,
}

export const Section: React.FC<React.PropsWithChildren<SectionProps>> = ({ children, delay = 0 }) => (
  <StyledDiv
    initial={{ y: 10, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transitionDuration={"0.8"}
    transitionDelay={`${delay}s`}
    mb={6}
  >
    {children}
  </StyledDiv>
);
